import { p as proxyCustomElement, H, c as createEvent, h, a as Host } from './index.js';
import { w as waitForAnimation } from './p-rUtJRH95.js';
import { d as defineCustomElement$7 } from './p-DhNzpZvu.js';
import { d as defineCustomElement$6 } from './p-B3XAsdJo.js';
import { d as defineCustomElement$5 } from './p-Dr61d_nc.js';
import { d as defineCustomElement$4 } from './p-D-dZjG8L.js';
import { d as defineCustomElement$3 } from './p-_P4kPR3l.js';
import { d as defineCustomElement$2 } from './p-CdhcNtiX.js';

const modalCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;bottom:0;box-sizing:border-box;display:block;font-family:Open Sans;font-size:.875rem;font-weight:400;left:0;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;overflow:auto;position:fixed;right:0;top:0;z-index:var(--jw-z-index-overlays)}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host .container{align-items:center;bottom:0;display:flex;justify-content:center;left:0;min-height:100%;pointer-events:none;position:relative;right:0;top:0;z-index:var(--jw-z-index-overlays)}:host .backdrop{background-color:#000000b3;bottom:0;left:0;opacity:0;pointer-events:none;position:fixed;right:0;top:0;transition:opacity .25s ease;z-index:calc(var(--jw-z-index-overlays) - 1)}:host .backdrop.-anim-fade-in{animation:fade-in .25s linear forwards;pointer-events:all}@keyframes fade-in{0%{opacity:0}to{opacity:1}}:host .backdrop.-anim-fade-out{animation:fade-out .25s linear forwards}@keyframes fade-out{0%{opacity:1}to{opacity:0}}:host .content{pointer-events:all;z-index:calc(var(--jw-z-index-overlays) + 1)}.container,.content{padding:2rem}.content{background-color:var(--jw-theme-surface-elevated-default-bg-color);border-color:var(--jw-theme-surface-border-border-color);border-radius:.375rem;box-shadow:var(--jw-theme-effects-shadow-shadow-xxl-box-shadow);color:var(--jw-theme-surface-text-default-color);display:flex;flex-direction:column;pointer-events:none;position:relative;transform:scale(0);transition:box-shadow .2s linear .01s}.content.-anim-open{animation:uv068h2 .5s cubic-bezier(.25,.46,.45,.94) forwards}@keyframes uv068h2{0%{opacity:0;transform:scale(.8)}90%{opacity:1}to{transform:scale(1)}}.content.-anim-close{animation:uv068i9 .5s cubic-bezier(.25,.46,.45,.94) forwards}@keyframes uv068i9{0%{opacity:1;transform:scale(1)}90%{opacity:0}to{opacity:0;transform:scale(.8)}}.content.-anim-minimize{animation:uv068jj .5s cubic-bezier(.23,1,.32,1) forwards}@keyframes uv068jj{0%{opacity:0;transform:translate(-8px,-8px);transform-origin:100% 0}to{opacity:1;transform:translate(0);transform-origin:50% 50%}}.content.-anim-minimize-from-max{animation:uv068kp .5s cubic-bezier(.23,1,.32,1) forwards}@keyframes uv068kp{0%{transform:scale(1.2)}to{transform:scale(1)}}.content.-anim-maximize{animation:uv068kw .5s cubic-bezier(.23,1,.32,1) forwards;overflow:auto}@keyframes uv068kw{0%{transform:scale(.8)}to{transform:scale(1)}}header{align-items:center;display:inline-flex;justify-content:flex-end}header h2{color:var(--jw-theme-surface-text-default-color);font-family:Open Sans;font-size:1.25rem;font-weight:400;letter-spacing:-.0008em;line-height:1.75rem;margin:0 auto 0 0;word-break:break-word}header[data-header-visible]{padding-bottom:2rem}.description p{font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;margin:0;max-width:480px;word-break:break-word}.body{display:flex;flex:1;flex-direction:column;gap:1rem}.actions{display:flex;flex:1}:host([size=sm]:not([data-display=mini]):not([data-display=max])) .content{width:var(--jw-container-md)}:host([size=md]:not([data-display=mini]):not([data-display=max])) .content{width:var(--jw-container-xl)}:host([size=lg]:not([data-display=mini]):not([data-display=max])) .content{width:var(--jw-container-2xl)}:host([data-display=open]) .content{pointer-events:all}:host([data-display=max]) .container{padding:0}:host([data-display=max]) .actions,:host([data-display=max]) .body{width:100%}:host([data-display=max]) .actions{flex:0}:host([data-display=max]) .content{border-radius:0;min-height:100vh;min-width:100vw;pointer-events:all}:host([data-display=max]) .content-inner{align-items:center;display:flex;flex-direction:column;flex-grow:1;justify-content:space-between;width:100%}:host([data-display=mini]){pointer-events:none}:host([data-display=mini]) .backdrop{opacity:0;pointer-events:none}:host([data-display=mini]) .content{bottom:1rem;box-shadow:var(--jw-theme-effects-shadow-shadow-lg-box-shadow);flex-direction:row;overflow:hidden;padding:.75rem 1rem;pointer-events:all;position:absolute;right:1rem;transition:min-width .35s ease}:host([data-display=mini]) .content-inner{align-items:center;display:flex;flex-direction:row}:host([data-display=mini]) .body{align-items:center;display:flex;flex:1;flex-direction:row;font-family:Open Sans;font-size:.875rem;font-weight:400;gap:.75rem;height:100%;letter-spacing:-.0004em;line-height:1.25rem}:host([data-display=mini]) .actions{align-items:center;border:none;display:flex;gap:.5rem;height:100%;white-space:nowrap}:host(:not([data-display=mini])) .body:last-child{margin-bottom:2rem}:host(:not([data-display=mini])) .actions{margin-top:2rem}::slotted([slot]){display:flex;flex:1;flex-direction:column}::slotted([slot=actions]),::slotted([slot=body-mini]){flex-direction:row}::slotted([slot=actions]){gap:.5rem}::slotted([slot=body-mini]){align-items:center;gap:.75rem;margin-right:.75rem;white-space:nowrap}";

const WuiModal$1 = /*@__PURE__*/ proxyCustomElement(class WuiModal extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.displayChanged = createEvent(this, "displayChanged", 3);
        /**
         * Modal header
         */
        this.header = '';
        /**
         * Modal description
         */
        this.description = '';
        /**
         * Modal theme
         */
        this.theme = 'light';
        /**
         * Modal width
         */
        this.size = 'sm';
        /**
         * Whether to show a backdrop behind the modal, overlaying the rest of the viewport.
         */
        this.backdrop = true;
        /**
         * Whether modal can be minimized (by clicking on backdrop or close button).
         */
        this.minimizable = false;
        /**
         * Whether modal can be maximized to fullscreen
         */
        this.maximizable = false;
        /**
         * Whether modal must be explicitly dismissed by an action.
         *
         * A blocking modal will prevent any other page interaction until the modal is dismissed.
         */
        this.blocking = false;
        /**
         * Action to take when clicking backdrop or close button.
         *
         * Defaults to `minimizeOrClose`. This means that it will try
         * to minimize if the modal allows it, else it will close.
         */
        this.dismissAction = 'minimizeOrClose';
        this.contentAnimClass = '';
        this.backdropAnimClass = '';
        this.display = 'closed';
        this.animate = async ({ backdrop, content, }) => {
            const shadowRoot = this.elm.shadowRoot;
            if (!shadowRoot) {
                return;
            }
            // Set waiter before toggling animation class
            const promise = Promise.all([
                backdrop ? waitForAnimation(shadowRoot.querySelector('.backdrop')) : Promise.resolve(),
                content ? waitForAnimation(shadowRoot.querySelector('.content')) : Promise.resolve(),
            ]);
            if (backdrop) {
                this.backdropAnimClass = backdrop;
            }
            if (content) {
                this.contentAnimClass = content;
            }
            await promise;
        };
        this.handleDismiss = () => {
            // Can't dismiss blocking modals
            if (this.blocking) {
                return;
            }
            switch (this.dismissAction) {
                case 'close':
                    this._setDisplay('closed');
                    break;
                case 'minimize':
                    this._setDisplay('mini');
                    break;
                default:
                    if (this.minimizable) {
                        this._setDisplay('mini');
                    }
                    else {
                        this._setDisplay('closed');
                    }
                    break;
            }
        };
        this.oldOverflow = '';
    }
    _display(newValue) {
        if (newValue === 'mini') {
            // If display changes to mini, we want the backdrop to scroll
            document.body.style.overflow = this.oldOverflow;
        }
        else {
            document.body.style.overflow = 'hidden';
        }
    }
    /**
     * Set display state.
     *
     * Possible values: `'open'`, `'closed'`, `'mini', 'max'`.
     */
    async setDisplay(value) {
        if (this.display === value) {
            return;
        }
        return this._setDisplay(value);
    }
    _setDisplay(value) {
        return new Promise((resolve) => {
            window.requestAnimationFrame(() => {
                const isMini = this.display === 'mini';
                const isOpen = this.display === 'open';
                const isClosed = this.display === 'closed';
                const isMax = this.display === 'max';
                switch (value) {
                    case 'open':
                        this.resetMiniActionsStyle();
                        this.animate(isClosed || isMini
                            ? {
                                backdrop: '-anim-fade-in',
                                content: '-anim-open',
                            }
                            : isMax
                                ? {
                                    backdrop: '-anim-fade-in',
                                    content: '-anim-minimize-from-max',
                                }
                                : {}).then(() => {
                            this.displayChanged.emit(this.display);
                            resolve();
                        });
                        this.display = 'open';
                        break;
                    case 'max':
                        this.animate({
                            backdrop: undefined,
                            content: '-anim-maximize',
                        }).then(() => {
                            this.displayChanged.emit(this.display);
                            resolve();
                        });
                        this.display = 'max';
                        break;
                    case 'closed':
                        this.animate({
                            backdrop: isMini ? undefined : '-anim-fade-out',
                            content: '-anim-close',
                        }).then(() => {
                            window.requestAnimationFrame(() => {
                                // Wait for animation to finish before persisting value
                                this.display = 'closed';
                                this.displayChanged.emit(this.display);
                                resolve();
                            });
                        });
                        break;
                    case 'mini':
                        this.resetMiniActionsStyle();
                        this.animate({
                            backdrop: isOpen ? '-anim-fade-out' : undefined,
                            content: '-anim-minimize',
                        }).then(() => {
                            this.displayChanged.emit(this.display);
                            resolve();
                        });
                        this.display = value;
                        break;
                    default:
                        resolve();
                        break;
                }
            });
        });
    }
    resetMiniActionsStyle() {
        const shadowRoot = this.elm.shadowRoot;
        if (!shadowRoot) {
            return;
        }
        const actionsEl = shadowRoot.querySelector('.actions');
        if (!actionsEl) {
            return;
        }
        actionsEl.style.width = '';
        actionsEl.style.opacity = '';
    }
    connectedCallback() {
        if (this.display !== 'mini') {
            this.oldOverflow = document.body.style.overflow;
            document.body.style.overflow = 'hidden';
        }
    }
    componentDidLoad() {
        const modalId = this.uid ? `wui_modal__${this.uid}` : '';
        const modal = document.getElementById(modalId);
        modal?.focus();
    }
    disconnectedCallback() {
        document.body.style.overflow = this.oldOverflow;
    }
    render() {
        const { header, description, backdrop, blocking, display, theme, uid, maximizable, minimizable, contentAnimClass, backdropAnimClass, } = this;
        const hasTitle = header && display !== 'mini';
        const isMaximizable = maximizable && display !== 'mini';
        const isMinimizable = minimizable && display !== 'mini';
        const showCloseButton = !blocking && !maximizable && !minimizable && display === 'open';
        return (h(Host, { key: 'c5748541b1e7f72f3373afc5c899cd087623c5a3', id: uid ? `wui_modal__${uid}` : '', "data-display": display, theme: theme, tabIndex: -1 }, backdrop && h("div", { key: '653689d5f216acb97ab663274831c2a5d46632c6', class: `backdrop ${backdropAnimClass}`, role: "button", onClick: this.handleDismiss }), h("div", { key: 'f1ec2861a41f44b8857ab1683d5b986cfc57f1da', class: "container" }, h("div", { key: '4b3346c6137dcaa750e384cb396ae125b52af07f', class: `content ${contentAnimClass}` }, h("header", { key: '280de6aa7a768be3f92369652c6aa70a82b6d8bc', "data-header-visible": hasTitle || showCloseButton || isMaximizable || isMinimizable }, hasTitle && h("h2", { key: 'b42f1f46ac58fd679d844f6ab446cb556dc65e36' }, header), showCloseButton && h("wui-close-button", { key: '9fe4ecffd748771ed0c382e5866a6206bacb6188', onClick: this.handleDismiss }), isMaximizable && (h("wui-button", { key: '2b88c2bbb21dd1e3f7c339ecf09b0b989215c288', type: "icon-ghost", icon: display === 'open' ? 'arrows-diagonal' : 'arrows-diagonal-minimize', onClick: () => this.setDisplay(display === 'max' ? 'open' : 'max'), tooltip: display === 'open' ? 'Maximize' : 'Minimize' })), isMinimizable && (h("wui-button", { key: '3a66ae8e47d0c52c434e94a666951f076af4e45d', type: "icon-ghost", icon: "arrows-diagonal-minimize", tooltip: "Minimize", onClick: () => this.setDisplay('mini') }))), h("div", { key: '4d7031347108ea5866692f01737e6d5d09fcdc6a', class: "content-inner" }, description && display !== 'mini' && (h("div", { key: '754ea503ad2fd053344b9a11aa91d13fa2083743', class: "description" }, description && h("p", { key: 'e4f6f1c87149a94910a3c579879188d5f55f51c3' }, description))), h("div", { key: 'e3b985ad816a296efdef567ca6658f7f8b9a5a3e', class: "body" }, display === 'mini' ? h("slot", { name: "body-mini" }) : h("slot", { name: "body" })), h("div", { key: 'be6449620ea3e61f45196c2168dd3e06cbf862df', class: "actions" }, display === 'mini' ? h("slot", { name: "actions-mini" }) : h("slot", { name: "actions" }), !blocking && display === 'mini' && h("wui-close-button", { key: 'c3f3252dee801536aa259488b1de873d15394d8a', onClick: this.handleDismiss })))))));
    }
    get elm() { return this; }
    static get watchers() { return {
        "display": ["_display"]
    }; }
    static get style() { return modalCss; }
}, [257, "wui-modal", {
        "uid": [1],
        "api": [16],
        "header": [1],
        "description": [1],
        "theme": [513],
        "size": [513],
        "backdrop": [4],
        "minimizable": [4],
        "maximizable": [4],
        "blocking": [4],
        "dismissAction": [1, "dismiss-action"],
        "contentAnimClass": [32],
        "backdropAnimClass": [32],
        "display": [32],
        "setDisplay": [64]
    }, undefined, {
        "display": ["_display"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-modal", "wui-button", "wui-close-button", "wui-icon", "wui-loader", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-modal":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiModal$1);
            }
            break;
        case "wui-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "wui-close-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiModal = WuiModal$1;
const defineCustomElement = defineCustomElement$1;

export { WuiModal, defineCustomElement };
